<template>
  <div class=''>
    <el-button size="mini" type="primary" @click="add">添加</el-button>
    <el-table
      :data="data"
      style="width: 100%;margin-top:10px">
      <el-table-column
        prop="complaint_type_name"
        label="类型名称">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.create_time|time}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="del(scope.row.complaint_type_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align:center">
      <el-pagination
        style="margin-top:10px"
        small
        background
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        @size-change="sizeChange"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data:[],
      page:{
        current:1,
        size:10,
        total:0
      }
    }
  },
  components: {},
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init(){
      this.$axios.get('/complaintType',{
        params:{
          current:this.page.current,
          size:this.page.size
        }
      }).then(res=>{
        this.data=res.data.records;
        this.page.total=res.data.total
      })
    },
    sizeChange(size){
      this.page.size=size;
      this.init();
    },
    currentChange(current){
      this.page.current=current;
      this.init();
    },
    add(){
      this.$prompt('类型名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请输入类型名称！'
      }).then(({ value }) => {
        this.$axios.post('/complaintType',{
          complaint_type_name:value
        }).then(res=>{
          this.$message.success('添加成功！');
          this.page.current=1;
          this.init();
        })
      }).catch(() => {

      });
    },
    del(id){
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete('/complaintType/'+id).then(res=>{
          this.$message.success('删除成功！');
          this.init();
        })
      }).catch(() => {

      });
    }
  }
}
</script>
<style scoped>

</style>